import { createContext, useContext } from 'react';
import type { PlateEditorConfigContextValue } from './types/types';

// Per-editor config that deeply-nested children (toolbar buttons, image
// element, paste handler within plugin) need to read. Threading through
// Plate's plugin system would require custom plugin keys; a React context
// is simpler and stays inside React's normal data-flow.
//
// Default upload source preserves the original hard-coded behavior so no
// existing consumer breaks if they don't wrap with a provider.
export const PlateEditorConfigContext = createContext<PlateEditorConfigContextValue>({
    uploadSource: 'one-pager',
    mentionableUsers: [],
});

export function usePlateEditorConfig(): PlateEditorConfigContextValue {
    return useContext(PlateEditorConfigContext);
}
